export interface SpeakingEngagement {
  slug: string
  title: string
  event: string
  date: string
  type: 'talk' | 'podcast' | 'workshop' | 'panel'
  description: string
  link?: string
}

export const speakingEngagements: SpeakingEngagement[] = [
  {
    slug: 'wrk-digital-2026',
    title: 'Leading Through the Noise: Making AI Stick in Engineering Teams',
    event: 'Wrk Digital: Leadership',
    date: 'Mar 2026',
    type: 'talk',
    description:
      'AI is evolving faster than engineering organisations can comfortably track, leaving leaders to cut through constant noise and hype. This talk focuses on how engineering leaders can drive real AI adoption through culture, experimentation and clear decision-making, turning rapid change into sustained team impact rather than fragmented tool use.',
  },
  {
    slug: 'digital-lighthouse-podcast-2026',
    title: 'AI in Banking',
    event: 'Digital Lighthouse Podcast',
    date: 'Feb 2026',
    type: 'podcast',
    description:
      'Discussion about my route into tech and adopting AI in a regulated business.',
  },
  {
    slug: 'conflux-case-study-2025',
    title:
      'Nimble scaling: LHV Bank accelerates value flow and strategic alignment through Team Topologies',
    event: 'Conflux Case Study',
    date: 'Dec 2025',
    type: 'workshop',
    description:
      'Hands-on workshops on restructuring engineering organisations for flow.',
    link: 'https://confluxhq.com/all-success-stories/nimble-scaling-lhv-bank-accelerates-value-flow-and-strategic-alignment-through-team-topologies',
  },
  {
    slug: 'open-banking-expo-2025-ai-data-automation',
    title: 'AI, Data & Automation: Redefining the Customer Experience',
    event: 'Open Banking Expo 2025',
    date: '12 Oct 2025',
    type: 'talk',
    description:
      'Session on how AI, data and automation are transforming customer experience in financial services, representing LHV Bank at Open Banking Expo 2025.',
    link: 'https://www.openbankingexpo.com',
  },
  {
    slug: 'york-fintech-forum-wealthtech-panel-2025',
    title: 'WealthTech Panel Discussion',
    event: 'FinTech North York FinTech Forum 2025',
    date: '16 Jul 2025',
    type: 'panel',
    description:
      'WealthTech themed panel at the York FinTech Forum 2025 featuring Macs Dickinson (Director of Engineering, LHV Bank), discussing innovation, opportunities and challenges in WealthTech with sector leaders.',
    link: 'https://www.fintechnorth.uk/events/york-fintech-forum/',
  },
  {
    slug: 'fintech-north-2024-scaling-panel-leeds',
    title: 'Scaling Panel Discussion',
    event: 'FinTech North Leeds Conference 2024',
    date: '22 May 2024',
    type: 'panel',
    description:
      'Panel on scaling FinTechs featuring Macs Dickinson (Director of Engineering, LHV Bank) alongside industry leaders, chaired by Julia Streets at the FinTech North Leeds Conference. Panel explored scaling strategies and growth challenges in UK fintech.',
    link: 'https://www.fintechnorth.uk/events/leeds-conference-2024/',
  },
  {
    slug: "byproduct-live-happily-married-product-engineering",
    title: "Happily Married Product & Engineering Teams with Macs Dickinson",
    event: "byProduct Live Podcast",
    date: "15th May 2024",
    type: "podcast",
    link: "https://open.spotify.com/episode/7oXVMBzitAglQVrtspBo53",
    description: "Podcast episode on byProduct Live discussing how product and engineering teams can work together effectively, featuring Macs Dickinson (LHV, ex-Flutter, SkyBet)."
  },
  {
    slug: 'intx-podcast-how-to-build-a-team-macs-dickinson',
    title: 'How to Build a Team with Head of Tech – Macs Dickinson',
    event: 'intx Podcast',
    date: '8 Mar 2023',
    type: 'podcast',
    description:
      'Discussion on building tech teams and career journeys in technology, featuring Macs Dickinson.',
    link: 'https://www.youtube.com/watch?v=JuUz79KXyA8',
  },
  {
    slug: 'react-context-api-techedge-2019-macs-dickinson',
    title: 'React Context API – Do You Really Need Redux?',
    event: 'TechEdge',
    date: '31 Oct 2018',
    type: 'talk',
    description:
      'TechEdge talk by Macs Dickinson on the React Context API and exploring whether Redux is necessary for state management in React apps.',
    link: 'https://www.youtube.com/watch?v=3gEs8ITZZO8',
  },
  {
    slug: 'ddd-north-2015-react-for-net-developers',
    title: 'React for .NET Developers',
    event: 'DDD North 2015',
    date: '27 Oct 2015',
    type: 'talk',
    description:
      "Talk introducing React to .NET developers, explaining how React's approach to data flow and interactive client-side UI can benefit ASP.NET applications, based on your session at DDD North 2015.",
    link: 'https://blog.scottlogic.com/2015/10/27/destroying-monoliths-at-dddnorth.html',
  },
]
